import React from 'react';
import { Box, FormControl, Option, Select, Typography } from '@mui/joy';

function SelectInputAutoForm(props) {
    // DONT USE value INSIDE THE SELECT. CHECK JOY UI DOCUMENTATION FOR MULTISELECT
    const { label, labelMinWidth, options, defaultValue, multiple, disabled, name, required } = props;

    return (
        <Box sx={{ display: 'flex'}}>
            <Typography sx={{ minWidth: labelMinWidth, alignSelf: "center", paddingRight: 1}}>
              {label}: 
            </Typography>
            <Select
              name={name}
              sx={{ minWidth: "30%"}}
              multiple={multiple}
              defaultValue={defaultValue}
              disabled={disabled}
              required={required}
            >
              {options.map((option, index) => {
                return (
                  <Option key={index} value={option}>
                      {option}
                  </Option>
              )})}
            </Select>
        </Box>
    );
}

export default SelectInputAutoForm;


